<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit MIC Type :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/admin/hse-types">
                            MIC Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-edit"></i> Edit</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.hse_type_name }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">MIC Type Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="hse_type_name" v-model="hse_type.hse_type_name" class="form-control" />
                                    <span v-if="errors.hse_type_name" class="text-danger">
                                        <span v-for="error in errors.hse_type_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="hse_type.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Include in MIC Report:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="hse_type.include_in_mic_report" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveHseType(this)" :disabled="saving">
                Save MIC Type
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                hse_type_id: this.$route.params.id,
                hse_type: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getHseType: function() {
                //Get the data
                this.$http
                    .get('admin/hse-types-edit' + (this.hse_type_id ? '/' + this.hse_type_id : ''))
                    .then(response => {
                        //Set all the data
                        this.hse_type = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveHseType: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/hse-types-edit' + (this.hse_type_id ? '/' + this.hse_type_id : ''), this.hse_type)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('MIC Type Saved');

                    //Return to main list?
                    this.$router.push('/admin/hse-types');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getHseType();
        }
    }
</script>
